import { ArrowRight } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Checkbox } from '@/components/ui/checkbox'
import { Label } from '@/components/ui/label'
import { FilterDropdown } from '@/components/ui/filter-dropdown'
import { typeLabels, unmatchedPath } from './types'
import type { useConnectionsList } from './useConnectionsList'

const typeOptions = Object.entries(typeLabels)
  .filter(([value]) => value !== 'fake')
  .map(([value, label]) => ({ value, label }))
const healthOptions = [
  { value: 'healthy', label: 'Healthy' },
  { value: 'failing', label: 'Failing' },
  { value: 'needs_attention', label: 'Needs attention' },
]
const statusOptions = [
  { value: 'active', label: 'Active' },
  { value: 'paused', label: 'Paused' },
  { value: 'removed', label: 'Removed' },
]
export function ConnectionsToolbar({
  state,
  unmatchedTotal,
}: {
  state: ReturnType<typeof useConnectionsList>
  unmatchedTotal?: number
}) {
  return (
    <>
      <FilterDropdown
        label="Type"
        emptyLabel="Type"
        options={typeOptions}
        selected={state.types}
        onChange={state.setTypes}
      />
      <FilterDropdown
        label="Health"
        emptyLabel="Health"
        options={healthOptions}
        selected={state.healths}
        onChange={state.setHealths}
      />
      <FilterDropdown
        label="Status"
        emptyLabel="Status"
        options={statusOptions}
        selected={state.statuses}
        onChange={state.setStatuses}
      />
      <Label className="flex items-center gap-2">
        <Checkbox
          checked={state.showRemoved}
          onCheckedChange={(checked) => state.setShowRemoved(checked === true)}
        />
        Show removed
      </Label>
      <Button
        asChild
        variant="ghost"
        className="ml-auto gap-1 text-muted-foreground hover:text-foreground"
      >
        <a href={unmatchedPath}>
          Unmatched items · {unmatchedTotal ?? '—'}
          <ArrowRight className="size-3.5" strokeWidth={1.5} />
        </a>
      </Button>
    </>
  )
}
